<template>
  <div>
    <div class="main-wrapper signin-form center signin-wrapper-padding">
      <div class="text-align-center margin-bottom-20 mm-logo"><img src="@/assets/MM-logo.png" /></div>
	    <h3 class="text-align-center margin-bottom-35">Loading ...</h3>
      <flash-message autoHide variant="success"></flash-message>
    </div>
  </div>
</template>
<style scoped>
.mm-logo img{ width: 240px; }
</style>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../router/index.js';
import store from '../store/store.js';
import axios from 'axios';

export default {
  data: function () {
    return {
    }
  },
  methods: {
  	navigate(path) {
  	  router.push(path);
  	},
  },
  created() {
    if(this.$route.params.code != '') {
      axios.get('/custom/code/' + this.$route.params.code, {

      })
      .then((resp) => {
         var url = resp.data.split('/');
         var notification_token = url[4];
         if(notification_token) {
           this.$store.dispatch('menteeemailnotification', notification_token)
           .then((resp) => {
              this.$store.dispatch('set_user_accountid', resp.data.userAccountId);
              this.navigate("/mentee-account-checkin-tasklists/" + resp.data.userAccountId);
            })
           .catch(err => {
             if(this.$store.state.status == 'error') {
               this.flash({ message: this.$store.state.err_message, variant: 'danger' });
               this.navigate("/login");
             }
           })
         }
         else {
          this.flash({ message: "Invalid link", variant: 'danger' });
          this.navigate("/login");
         }
       })
      .catch(err => {
          this.flash({ message: err.response.data.message, variant: 'danger' });
          this.navigate("/login");
      })
    }
    else {
      this.flash({ message: 'Invalid User Crediantials', variant: 'danger' });
      this.navigate("/login");
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sms_code_validation.vue